module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMiIgaGVpZ2h0PSI1MyIgdmlld0JveD0iMCAwIDIgNTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjEiIGhlaWdodD0iNTIiIHN0cm9rZT0iIzk4OUE5QyIgc3Ryb2tlLWRhc2hhcnJheT0iMyA1Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xxing.svg
// module id = djjZ
// module chunks = 1